import { appStyles } from '../../App.styles';
export const /** LanguageSG Styles */ languageSGStyles = {
    autocomplete: Object.assign(Object.assign({}, appStyles.text16), { marginTop: '0.5rem', padding: '0', maxWidth: '21rem', width: {
            ls: '21rem',
            xs: '100%',
        }, color: 'blackDark.main' })
};
